import React from 'react'

import soundStyles from './playButton.module.scss'

const SoundButton = ({ className, onClick, paused, videoReady }) => (
  <button
    className={`
    ${className || ''} ${soundStyles.button}
    ${videoReady ? soundStyles.button__show : ''}`}
    onClick={onClick}
  >
    <div
      className={`${soundStyles.label} ${!paused ? soundStyles.playing : ''}`}
    ></div>
  </button>
)

export default SoundButton
